$('.js-video-watch-again-btn').on('click', function () {
    $(document).trigger('watchAgainEvent');

    if (!isOverlayed && !isFrostlined) {
        $(document).trigger('watchAgainZoomEvent');
    }
    if (isOverlayed) {
        $(document).trigger('watchAgainOverlayEvent');
    }
});

$(document).on('watchAgainEvent', function () {
    stopCountdown();
    playerBase.load();
    playerBase.currentTime(0);
    playerBase.play();
});

$(document).on('watchAgainZoomEvent', function () {
    zoomPlayer.load();
    zoomPlayer.currentTime = 0;
    zoomPlayer.play();
});
